import React from 'react'
import './login.css'
import LoginForm from './LoginForm.js';
import './login.css'

const Login = () =>
{
    return (
        <section id="hero" className="d-flex align-items-center justify-content-center" style={{backgroundColor: '#dfe2ea', top: "center", width: '100%'}}>
            <div className="container custom-sm" data-aos="fade-up">
                <div className="justify-content-center align-items-center rounded-4" data-aos="zoom-in" data-aos-delay="250">
                    <LoginForm/>
                </div>
            </div>
        </section>
    )
}

export default Login